import { Card, CardHeader } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import logger from "../../../services/logger";
import Form from "../../common/form";
import {
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../../common/formUtils";
import roomJson from "./room.json"
import roomService from "./room.service";
import employeeService from "../../../services/employeeService";
import busService from "../manage-hostels/hostel.service";

class RoomForm extends Form {
  constructor() {
    super();
    this.formJson = roomJson;
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }


  async componentDidMount() {

    await this.populateForm();
  }


  async populateForm() {
    const id = this.props.id;
    if (id === "new") return;
    try {
      const { data } = await roomService.get(id);
      this.mapToViewModel(data);
    } catch (ex) {
      logger.error(ex);
    }
  }

  async getBuses(){
    const {data:buses}=await busService.getAll();
    const dropDowns={...this.state.dropDowns}
    dropDowns.buses=buses;
    this.setState({dropDowns});
    }

    async getDrivers(){
      const {data:drivers}=await employeeService.getAllByRole("BUS_DRIVER");
      const {data:attenders}=await employeeService.getAllByRole("BUS_ATTENDER");

      const dropDowns={...this.state.dropDowns}
      dropDowns.drivers=drivers;
      dropDowns.attenders=attenders;
      this.setState({dropDowns});
    }
  

  doSubmit = async (id) => {
    try {
      if (id === "new") {
        await roomService.create(this.state.data);
      } else {
        await roomService.partialUpdate(this.state.data,id);
      }
      this.props.onSave();
    } catch (ex) {
      logger.log(ex);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.id;

    const titleText = getFormTitleText(id, this.formJson.alias);

    return (
      <Card>
        <form onSubmit={(event) => this.handleSubmit(event, id)}>
          <CardHeader title={t(titleText)} />
          {this.renderForm(this.formJson, dropDowns)}
          {/* <CardContent>
            <Grid container item sm={12} md={12} direction="row-reverse">
              {this.renderMatButton(t(buttonText))}
              {this.renderMatButton(t("common:Reset"), "reset", "secondary")}
            </Grid>
          </CardContent> */}
        </form>
      </Card>
    );
  }
}

export default withTranslation(["room", "common"])(
  RoomForm
);
